import { useState, useCallback } from "react";

const useIsVisible = (initialValue:boolean) => {
  const [visible, setValue] = useState(initialValue);
  const setVisible = useCallback((isVisible: boolean) => {
    setValue(isVisible);
  }, []);
  return { visible, setVisible };
};

export default useIsVisible;
